import { render } from "./FullScreen.vue?vue&type=template&id=25487914&scoped=true&ts=true"
import script from "./FullScreen.vue?vue&type=script&lang=ts"
export * from "./FullScreen.vue?vue&type=script&lang=ts"

import "./FullScreen.vue?vue&type=style&index=0&id=25487914&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25487914"]])

export default __exports__